import { z } from 'zod';

export const RegisterCustomerVehicleBodySchema = z.object({
  vehicleModelId: z.uuid(),
  plate: z.string().trim().optional(),
  chassis: z.string().trim().optional(),
  color: z.string().trim().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).optional(),
  modelYear: z.number().int().min(1900).max(2100).optional(),
  fipeCode: z.string().trim().optional(),
  vehicleGenerationId: z.uuid().optional(),
  vehicleTrimId: z.uuid().optional(),
  vehicleEngineId: z.uuid().optional(),
  engineNumber: z.string().trim().optional(),
  engineNumberSource: z.enum(['LOOKUP', 'MANUAL']).optional(),
  nickname: z.string().trim().optional(),
  notes: z.string().trim().optional(),
  acquiredAt: z.iso.date().optional(),
  reuseVehicleId: z.uuid().optional(),
});

export type RegisterCustomerVehicleBody = z.infer<typeof RegisterCustomerVehicleBodySchema>;

export const RegisterCustomerVehicleResponseSchema = z.object({
  customerVehicleId: z.uuid(),
});

export type RegisterCustomerVehicleResponse = z.infer<typeof RegisterCustomerVehicleResponseSchema>;
